$(function () {
	// パスの取得
	let path = location.pathname;
	let url = location.href;
	if (path==="/info" || url.match(/info/)) {
		$(".cat-item-all").addClass("current-cat");	
	}
});